import { useEffect, useRef, useState } from "react";
import { StyledEditableText } from "./index.styled";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

type Props = {
  text: string | JSX.Element;
  editComponent: JSX.Element;
  initialIsEdit?: boolean;
  forceEdit?: boolean;
  saveOnClick?: () => void;
};

export default function EditableText(props: Props) {
  const { text, editComponent, initialIsEdit, forceEdit, saveOnClick } = props;
  const [isEdit, setIsEdit] = useState<boolean>(!!initialIsEdit);
  const editRef = useRef();

  useEffect(() => {
    if (!editRef?.current) return;
    const target = editRef?.current as HTMLElement;

    const event = (event: KeyboardEvent) => {
      if (target) {
        switch (event.key) {
          case "Enter":
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            setIsEdit(false);
            if (saveOnClick) saveOnClick();
            break;

          case "Escape":
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            setIsEdit(false);
            break;

          default:
            break;
        }
      }
    };
    target?.addEventListener("keydown", event, true);

    return () => {
      target?.removeEventListener("keydown", event);
    };
  }, [editRef, text]);

  if (isEdit || forceEdit) {
    return (
      <StyledEditableText
        ref={editRef}
        // onBlurCapture={() => setIsEdit(false)}
        className="editable-text"
      >
        {editComponent}

        <ActionButton
          type="save"
          noLabel
          noBg
          size="small"
          onClick={() => {
            setIsEdit(false);
            if (saveOnClick) saveOnClick();
          }}
        />
      </StyledEditableText>
    );
  }

  return (
    <StyledEditableText
      onClick={() => setIsEdit(true)}
      className="editable-text"
    >
      {text || "-"}
      <ActionButton type="edit" noLabel noBg size="small" />
    </StyledEditableText>
  );
}
